<template>
    <div id="burger" v-bind:class="{ 'active' : isBurgerActive }" v-on:click.stop="toggle" class="hamburger">
        <slot>
            <button type="button" title="Menu">
                <i class="fa fa-bars" aria-hidden="true"></i>
            </button>
        </slot>
    </div>
</template>

<script>
    import { store, mutations } from '@/store.js'

    export default {
        name: "Burger.vue",
        computed: {
            isBurgerActive() {
                return store.isNavOpen
            }
        },
        methods: {
            toggle() {
                mutations.toggleNav()
            }
        }
    }
</script>

<style scoped>
    .hamburger button {
        border: none;
        background: none;
        color: #fff;
    }
</style>